module.exports = __webpack_public_path__ + "img/hkDetailBg.4f813bba.png";